export type FloorSectionId = '2A' | '2B' | '2C';

export const SECOND_FLOOR_SECTIONS: { id: FloorSectionId; label: string }[] = [
  { id: '2C', label: '2C' },
  { id: '2B', label: '2B' },
  { id: '2A', label: '2A' }
];

export const SECOND_FLOOR_SHELF_CODES = [
  '2A1',
  '2A2',
  '2A3',
  '2A4',
  '2A5',
  '2A6',
  '2A7',
  '2A8',
  '2A9',
  '2A10',
  '2A11',
  '2B1',
  '2B2',
  '2B3',
  '2B4',
  '2B5',
  '2B6',
  '2B7',
  '2B8',
  '2C1',
  '2C2',
  '2C3',
  '2C4',
  '2C5',
  '2C6',
  '2C7',
  '2C8',
  '2C9',
  '2C10',
  '2C11',
  '2C12',
  '2C13'
] as const;

export const isSecondFloorShelfCode = (code?: string | null) =>
  /^2[ABC]\d+/i.test(code ?? '');

export const hasSecondFloorShelves = (shelfCodes: string[] = []) =>
  shelfCodes.some(isSecondFloorShelfCode);

export const STOREFRONT_LOCATION_NAME = 'Storefront';

export const STOREFRONT_SHELF_CODES = [
  'S1',
  'S2-A',
  'S2-B',
  'S3-A',
  'S3-B',
  'S4-A',
  'S4-B',
  'S5',
  'S6-A',
  'S6-B',
  'S7',
  'S8'
] as const;

export const isStorefrontShelfCode = (code?: string | null) =>
  /^S\d+(?:-[A-Z])?$/i.test(code ?? '');

export const hasStorefrontShelves = (shelfCodes: string[] = []) =>
  shelfCodes.some(isStorefrontShelfCode);

export const isStorefrontLocationName = (name?: string | null) =>
  (name ?? '').trim().toLowerCase() === STOREFRONT_LOCATION_NAME.toLowerCase();

export const naturalShelfCodeCompare = (a: string, b: string) => {
  const parse = (value: string) => {
    const match = value.match(/^(.*?)(\d+)(?:-([A-Za-z]))?$/);
    return {
      prefix: (match?.[1] ?? value).toUpperCase(),
      number: match?.[2] ? Number(match[2]) : 0,
      suffix: (match?.[3] ?? '').toUpperCase()
    };
  };
  const left = parse(a);
  const right = parse(b);
  if (left.prefix !== right.prefix) return left.prefix.localeCompare(right.prefix);
  if (left.number !== right.number) return left.number - right.number;
  return left.suffix.localeCompare(right.suffix);
};
